import template from './_form.pug'

const Fields = ['id', 'name', 'description', 'promt']

export default Vue.extend({
  template: template(),
  props: {
    initData: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      data: {}
    }
  },
  computed: {
    modeForm() {
      return this.data.id ? 'edit' : 'new'
    },
    isEditing() {
      return this.modeForm === 'edit'
    },
    saveButtonText() {
      return this.t(`saveButton.${this.modeForm}`)
    }
  },
  watch: {
    initData: {
      immediate: true,
      handler() {
        this.initializeData()
      }
    }
  },
  methods: {
    initializeData() {
      const data = {}
      Fields.forEach(key => {
        data[key] = this.initData ? this.initData[key] : ''
      })
      this.data = data
    },
    t(key, options = {}) {
      return this.$t(`promtsAi.form.${key}`, options)
    },
    submit() {
      this.$emit('submit', this.data)
    },
    cancel() {
      this.$router.push({ name: 'accounts-laia-promts', params: { id: this.$route.params.id } })
    }
  }
})
